<div class="promo-section">
  <div class="promo-text">
    <h1 class="x-large" [innerHTML]="'landing.ad.promo.title' | translate"></h1>
    <p>{{ 'landing.ad.promo.subtitle' | translate }}</p>
    <div class="flex gap-4 promo-cta">
      <app-button
        customIconSrc="/assets/icons/magic-wand.svg"
        size="x-large"
        [shadow]="false"
        routerLink="project"
        fragment="top"
        [label]="'landing.ad.promo.cta_create' | translate">
      </app-button>
      <app-button
        class="promo-secondary-cta"
        size="large"
        [shadow]="false"
        color="pink"
        routerLink="project"
        fragment="top"
        [label]="'landing.ad.promo.cta_inspire' | translate">
      </app-button>
    </div>
  </div>
  <div class="promo-slider">
    <p-carousel
      [value]="products"
      [numVisible]="1"
      [numScroll]="1"
      [circular]="false"
      [showNavigators]="false"
      autoplayInterval="5000"
    >
      <ng-template let-product #item>
        <div class="relative">
          <img class="w-full" [src]="product.images[0]?.urls?.large" [alt]="product.name" />
          <div class="flex justify-content-center">
            <div class="pill-white" [routerLink]="projectLink" [queryParams]="{ productId: product.id }" fragment="top">
              <span>{{ product.name }}</span>
            </div>
          </div>
        </div>
      </ng-template>
    </p-carousel>
  </div>
</div>
